/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ChevronUp/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ChevronUp({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ChevronUp",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ChevronUp.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Z1oVAsq': alignSelf,'--mt-2-Z1oVAsq': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1oVAsq': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1oVAsq': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1oVAsq': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1oVAsq': opacity,'--w-10-Z1oVAsq': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1oVAsq': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1oVAsq': fill,'--a-7-Z1oVAsq': isAnimated ? animation : "none",'--sd-8-Z1oVAsq': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1oVAsq': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ChevronUp.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.782 9.494a.778.778 0 010-1.1l4.392-4.391a1.167 1.167 0 011.65 0l4.392 4.391a.778.778 0 01-1.1 1.1L6.999 5.378 2.882 9.494a.778.778 0 01-1.1 0z"
 style={{'--f-12-Z1oVAsq': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}